/**
 * @file
 */

export function handleMultipleDueDates() {
    var nextPaymentHeading = $("[id*='hNextPayment']");
    var nextPaymentDate = $("[id*='tdNextPaymentDate']");
    var nextPaymentLabel = $("[id*='lblNextPayment']");

    nextPaymentHeading.text("Total Payments Due *");
    nextPaymentDate.addClass("hide");
    nextPaymentLabel.text("Next Payment Date *")
}
